<template>
  <el-card>
    <div slot="header" class="font-weight-bold text-left">
      {{ $t('general.other_information') }}
    </div>
    <div>
      <table class="el-table el-table--striped">
        <tr v-if="information.contactAtLocation">
          <th class="w-50 pr-1">
            {{ $t('placeholder.contact_at_location') }}
          </th>
          <td>{{ information.contactAtLocation }}</td>
        </tr>
        <tr v-if="information.adjoiningArea">
          <th class="w-50 pr-1">
            {{ $t('checkout.reference_id') }}
          </th>
          <td>{{ information.referenceId }}</td>
        </tr>
        <tr>
          <th class="w-50 pr-1">
            {{ $t('checkout.lkw_ramp') }}
          </th>
          <td>{{ information.lkw ? $t('general.yes') : $t('general.no') }}</td>
        </tr>
        <tr v-if="information.project">
          <th class="w-50 pr-1">
            {{ $t('checkout.project') }}
          </th>
          <td>{{ information.project }}</td>
        </tr>
        <tr v-if="information.phone">
          <th class="w-50 pr-1">
            {{ $t('general.phone') }}
          </th>
          <td>{{ information.phone }}</td>
        </tr>
        <tr v-if="information.documentsRequired">
          <th class="w-50 pr-1">
            Documents required
          </th>
          <td>{{ information.documentsRequired }}</td>
        </tr>
        <tr v-if="information.termsOfDelivery">
          <th>Terms of Delivery</th>
          <th>
            <span>
              FCA:
              <i v-if="information.termsOfDelivery.fca" class="el-icon-check" />
              <i v-else class="el-icon-close" />
            </span>
            <span>
              CIP:
              <i v-if="information.termsOfDelivery.cip" class="el-icon-check" />
              <i v-else class="el-icon-close" />
            </span>
            <span v-if="information.termsOfDelivery.cip">
              Unloading equipment required(for CIP only):
              <i v-if="information.termsOfDelivery.unloadingEquipment" class="el-icon-check" />
              <i v-else class="el-icon-close" />
            </span>
            <span>
              CIF:
              <i v-if="information.termsOfDelivery.cif" class="el-icon-check" />
              <i v-else class="el-icon-close" />
            </span>
          </th>
        </tr>
      </table>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'OrderInformationCard',
  components: {},
  props: {
    information: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
